import { FC } from 'react'

import HintMessage from 'components/parts/hint-message/hint-message'

import numericToWord from 'utils/numericToWord'
import { NoQuestionsWebinars } from 'constants/webinar-data'

interface IAboutNMO {
  id?: number
  points?: number | null
  NMOTimeLength?: number
  checkupCount?: any
  hasSponsor?: boolean
}

const formatTimetoMinutes = (ms: number) => ms / 60 / 1000
const minutesVariants = ['минут', 'минута']

const AboutNMO: FC<IAboutNMO> = ({ id, points, NMOTimeLength, checkupCount }) => {
  const NMOTimeRequired = formatTimetoMinutes(NMOTimeLength || 0)
  const formatedCount = Number(checkupCount) || 0
  const NMOMinuteWord = numericToWord(Number(NMOTimeRequired), minutesVariants)

  return (
    <>
      <p>
        Во время мероприятия ведётся{' '}
        <HintMessage message="Контроль присутствия - всплывающее окно, сопровождаемое звуковым сигналом для НМО.">
          учёт времени присутствия слушателей
        </HintMessage>
        . Для подтверждения присутствия на мероприятии участники должны отметиться на всплывающем
        окне. Количество проверок на мероприятии — <b>{formatedCount}</b>.&ensp;
        {points && points < formatedCount
          ? `Условия подтверждения присутствия считаются выполненными пользователем, если пользователь подтвердил присутствие не менее ${id === 1538 ? '6' : points} контролей из ${formatedCount}.`
          : ''}
        &ensp;Продолжительность участия в мероприятии -&ensp;
        <b>
          {NMOTimeRequired}
          &ensp;
          {NMOMinuteWord}.
        </b>
        &ensp;
      </p>
      <br />
      <p>
        Во время мероприятия участникам доступны возможность общения в общем чате
        {id && !NoQuestionsWebinars.includes(id) && ' и возможность задать вопросы лекторам'}.
      </p>
    </>
  )
}

export default AboutNMO
